import { useState as i, useRef as k, useMemo as c, useCallback as C } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import N from "../../../../../core/Context/useCoreContext.js";
import R from "../../../Calendar/calendar/timerange/presets/lastNDays.js";
import q from "../../../Calendar/calendar/timerange/presets/thisWeek.js";
import v from "../../../Calendar/calendar/timerange/presets/lastWeek.js";
import A from "../../../Calendar/calendar/timerange/presets/thisMonth.js";
import E from "../../../Calendar/calendar/timerange/presets/lastMonth.js";
import K from "../../../Calendar/calendar/timerange/presets/yearToDate.js";
const X = () => Object.freeze({
  "rangePreset.last7Days": R(7),
  "rangePreset.last30Days": R(30),
  "rangePreset.thisWeek": q(),
  "rangePreset.lastWeek": v(),
  "rangePreset.thisMonth": A(),
  "rangePreset.lastMonth": E(),
  "rangePreset.yearToDate": K()
}), Y = ({
  now: a = Date.now(),
  options: s,
  selectedOption: m,
  timezone: u
}) => {
  const { i18n: f } = N(), [W, h] = i(), [j, d] = i(), [l, g] = i(), S = k(), y = k(), [t, D, n] = c(() => {
    const o = f.get("rangePreset.custom"), e = Object.keys(s), r = Object.freeze(e.map((O) => f.get(O)));
    return [o, (O, F = r) => {
      const z = F.findIndex((I) => I === O);
      return s[e[z]];
    }, r];
  }, [f, s]), [P, T] = i(m === t), b = c(() => Object.freeze([...n, t]), [t, n]), M = c(
    () => P ? b : n,
    [P, n, b]
  ), p = C(
    (o) => {
      const e = D(o, n);
      e && (h(e.from), d(e.to), T(!1), g(o));
    },
    [t, D, l, n]
  ), x = C(() => {
    h(void 0), d(void 0), T(!0), g(t);
  }, [t]);
  return c(() => {
    m === t ? g(t) : p(m);
  }, []), c(() => {
    var o;
    if (S.current !== a || y.current !== u) {
      const e = Object.values(s);
      e.forEach((r) => {
        r.now = a, r.timezone = u;
      }), S.current = a, y.current = (o = e[0]) == null ? void 0 : o.timezone, p(l);
    }
  }, [a, u, s]), {
    customSelection: x,
    from: W,
    onSelection: p,
    options: M,
    selectedOption: l,
    to: j
  };
};
export {
  Y as default,
  X as getTimeRangeSelectionDefaultPresetOptions,
  Y as useTimeRangeSelection
};
